import { Route, Routes } from 'react-router-dom';
import Guest from '../../middleware/Guest';
import GuestLayout from '../../layouts/guest/GestLayout';
import Signup from '../../pages/auth/Signup';
import ForgetPassword from '../../pages/auth/ForgetPassword';
import EmailConfirmation from '../../pages/auth/EmailConfirmation';
import ResetPassword from '../../pages/auth/ResetPassword';
import Login from '../../pages/auth/Login';
import ErrorPage from '../../components/errorPage/ErrorPage';

const AuthRoutes = () => {
    return (
        <Routes>
            {/* Auth Routes and layout  */}
            <Route
                element={
                    <Guest>
                        <GuestLayout />
                    </Guest>
                }
            >
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgetpassword" element={<ForgetPassword />} />
                <Route path="/emailconfirmation/:email" element={<EmailConfirmation />} />
                <Route path="/auth/password-reset/:token" element={<ResetPassword />} />
                <Route
                    path="*"
                    element={<ErrorPage status={404} error={'هذه الصفحة غير موجودة'} />}
                />
            </Route>
        </Routes>
    );
};

export default AuthRoutes;
